var GeneralPropertyDataToGoModelUtil = /** @class */ (function () {
    function GeneralPropertyDataToGoModelUtil(diagram, goModel) {
        this.diagram = diagram;
        this.goModel = goModel;
    }
    GeneralPropertyDataToGoModelUtil.prototype.saveComponentProperty = function (property, value) {
        this.diagram.model.setDataProperty(this.goModel, property, value);
    };
    GeneralPropertyDataToGoModelUtil.prototype.saveToGoJsModel = function (data) {
        this.saveComponentProperty('direction', data.direction);
        this.saveComponentProperty('min', data.minValue);
        this.saveComponentProperty('max', data.maxValue);
        this.saveComponentProperty('variableName', data.configureVariableId && data.configureVariableId.name ?
            data.configureVariableId.name : '');
        this.saveComponentProperty('variableVersion', data.configureVariableId && data.configureVariableId.variableVersion ?
            data.configureVariableId.variableVersion : undefined);
        this.saveComponentProperty('variableDataType', data.variableDataType ?
            data.variableDataType : undefined);
    };
    return GeneralPropertyDataToGoModelUtil;
}());
export { GeneralPropertyDataToGoModelUtil };
